import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getCurrentUser, updatePassword } from "aws-amplify/auth";

import Validate from "../utility/FormValidation";
import { Box, Paper, Stack } from '@mui/material';
//import { IoTJobsDataPlane } from 'aws-sdk';
import Typography from '@mui/material/Typography';

import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import logo from './../../logos/Logo_Cerchio_1000px.svg'
import bgImage from '../../background/bgd_login.jpg'


import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';

export default function ChangePassword() {

    const history = useHistory();

    const [credentialsForm, setCredentialsForm] = useState({
        username: '',
        password: '',
        oldPassword: "",
        confirmPassword: "",
        showPassword: false,
        errors: {
            username: "",
            email: "",
            password: "",
            oldPassword: "",
            confirmPassword: "",
            cognito: ""
        },
        isLogging: false
    });

    const [alertDialog, setAlertDialog] = useState(false)

    const handleSubmit = async () => {
        try {
            setCredentialsForm({ ...credentialsForm, isLogging: true, })
            const user = await getCurrentUser();
            //console.log(user);
            await updatePassword({
                oldPassword: credentialsForm.oldPassword,
                newPassword: credentialsForm.password
            });
            setCredentialsForm({ ...credentialsForm, isLogging: false, })
            setAlertDialog(true)

        } catch (error) {
            setCredentialsForm({
                ...credentialsForm,
                errors: {
                    ...credentialsForm.errors,
                    cognito: error.message || 'Unexpect error during authentication',
                },
                isLogging: false
            });
        }
    }


    const onInputChange = event => {
        const error = Validate({ ...credentialsForm, [event.target.id]: event.target.value });
        // console.log(error)
        setCredentialsForm({
            ...credentialsForm,
            [event.target.id]: event.target.value,
            errors: { ...credentialsForm.errors, ...error, cognito: null }
        });

    }

    const handleClickShowPassword = () => {
        setCredentialsForm({
            ...credentialsForm,
            showPassword: !credentialsForm.showPassword,
        });
    };
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };


    const redirect = (dst) => {
        history.push(dst);
    }

    const handleEnterKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSubmit()
        }
    }

    return (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                overflow: 'hidden',
                height: '100vh',
                width: '100%',
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            }}
            id='bg-container'
        >

            <Paper sx={{ width: '60%', minWidth: '23em', maxWidth: '40em', m: 'auto', marginTop: '8em', paddingTop: '2em' }} elevation={3}>
                <Stack
                    component="form"
                    noValidate
                    autoComplete="new-password"
                    direction='column'
                    alignItems='center'
                >

                    <img src={logo} height="100" alt="pagination logo" />

                    <Typography variant='caption' sx={{ m: '1em', marginBottom: '2em', marginTop: '2em' }}>
                        Password must have at least 8 characters, upper and lower case, a number.
                    </Typography>

                    <FormControl sx={{ m: 1, width: '80%', maxWidth: '30em' }} variant="outlined">
                        <InputLabel error={credentialsForm.errors.oldPassword !== ""}>
                            Old password
                        </InputLabel>
                        <OutlinedInput
                            id="oldPassword"
                            label="Old password"
                            type={credentialsForm.showPassword ? 'text' : 'password'}
                            value={credentialsForm.oldPassword}
                            onChange={onInputChange}
                            error={credentialsForm.errors.oldPassword !== ""}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {credentialsForm.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            onKeyDown={handleEnterKeyDown}
                        />
                        {credentialsForm.errors.oldPassword !== "" &&
                            <FormHelperText
                                error={true}
                                id="pass-err">
                                {credentialsForm.errors.oldPassword}
                            </FormHelperText>
                        }
                    </FormControl>

                    <FormControl sx={{ m: 1, width: '80%', maxWidth: '30em' }} variant="outlined">
                        <InputLabel error={credentialsForm.errors.password !== ""}>
                            Password
                        </InputLabel>
                        <OutlinedInput
                            id="password"
                            label="password"
                            type={credentialsForm.showPassword ? 'text' : 'password'}
                            value={credentialsForm.password}
                            onChange={onInputChange}
                            error={credentialsForm.errors.password !== ""}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {credentialsForm.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            onKeyDown={handleEnterKeyDown}
                        />
                        {credentialsForm.errors.password !== "" &&
                            <FormHelperText
                                error={true}
                                id="pass-err">
                                {credentialsForm.errors.password}
                            </FormHelperText>
                        }
                    </FormControl>

                    <FormControl sx={{ m: 1, width: '80%', maxWidth: '30em' }} variant="outlined">
                        <InputLabel error={credentialsForm.errors.confirmPassword !== ""}>
                            Confirm password
                        </InputLabel>
                        <OutlinedInput
                            id="confirmPassword"
                            label="Confirm password"
                            type={credentialsForm.showPassword ? 'text' : 'password'}
                            value={credentialsForm.confirmPassword}
                            onChange={onInputChange}
                            error={credentialsForm.errors.confirmPassword !== ""}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {credentialsForm.showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            onKeyDown={handleEnterKeyDown}
                        />
                        {credentialsForm.errors.confirmPassword !== "" &&
                            <FormHelperText
                                error={true}
                                id="pass-err">
                                {credentialsForm.errors.confirmPassword}
                            </FormHelperText>
                        }
                    </FormControl>


                    {credentialsForm.errors.cognito !== undefined &&
                        <Typography variant='caption' color='error' sx={{ marginBottom: '1em' }}>
                            {credentialsForm.errors.cognito}
                        </Typography>
                    }

                    <Button
                        color="primary"
                        disabled={(credentialsForm.password === '' || credentialsForm.confirmPassword === '') || credentialsForm.errors.password !== '' || credentialsForm.errors.confirmPassword !== ''}
                        loading={credentialsForm.isLogging}
                        //loadingPosition="start"
                        variant="contained"

                        onClick={handleSubmit}
                        sx={{ m: '2em', marginTop: '1em' }}
                    >
                        Change password
                    </Button>

                    <Dialog open={alertDialog}>
                        <DialogTitle>Your password has been changed!</DialogTitle>
                        <Button onClick={() => redirect('/dashboard')}>Back to Dashboard</Button>
                    </Dialog>


                </Stack >
            </Paper>
        </Box>

    )

}


